/**
 * 首页组件 - 中华非遗主页
 * 包含两阶段动画：广东非遗元素展示 -> 功能圆圈交互
 */
<template>
  <div class="home-page">
    <!-- 首页英雄区块 -->
    <section class="hero-section" id="heroSection">
      <!-- 第一阶段：清晰的广东非遗元素图 -->
      <div 
        class="heritage-image-container" 
        id="heritageImage"
        :class="{ 'blurred': showInteractive }"
      >
        <div class="heritage-image">
          <div class="heritage-elements">
            <!-- 广东非遗元素装饰 -->
            <div class="element element-1">
              <i class="fas fa-dragon"></i>
              <span>龙舟竞渡</span>
            </div>
            <div class="element element-2">
              <i class="fas fa-cut"></i>
              <span>剪纸艺术</span>
            </div>
            <div class="element element-3">
              <i class="fas fa-theater-masks"></i>
              <span>粤剧表演</span>
            </div>
            <div class="element element-4">
              <i class="fas fa-palette"></i>
              <span>象牙雕刻</span>
            </div>
            <div class="element element-5">
              <i class="fas fa-mug-hot"></i>
              <span>英德红茶</span>
            </div>
            <div class="element element-6">
              <i class="fas fa-hand-rock"></i>
              <span>雷州石狗</span>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 第二阶段：三个功能圆圈 -->
      <div 
        class="interactive-content" 
        id="interactiveContent"
        :class="{ 'active': showInteractive }"
      >
        <!-- 三角形布局的三个功能区 -->
        <div class="triangle-layout">
          <router-link to="/about" class="function-circle-link">
            <div class="function-circle circle-about" data-theme="about">
              <div class="circle-icon">
                <i class="fas fa-book-open"></i>
              </div>
              <div class="circle-content">
                <h3>寻迹识非遗</h3>
                <p>搭建智慧桥梁，实现非遗与科学课堂双向奔赴，开启知识图谱教育新篇</p>
              </div>
            </div>
          </router-link>
          
          <router-link to="/explore" class="function-circle-link">
            <div class="function-circle circle-explore" data-theme="explore">
              <div class="circle-icon">
                <i class="fas fa-search"></i>
              </div>
              <div class="circle-content">
                <h3>科学解非遗</h3>
                <p>对标优秀案例，启动多模态AI灵感引擎，智启科学课堂新想象</p>
              </div>
            </div>
          </router-link>
          
          <router-link to="/heritage" class="function-circle-link">
            <div class="function-circle circle-heritage" data-theme="heritage">
              <div class="circle-icon">
                <i class="fas fa-graduation-cap"></i>
              </div>
              <div class="circle-content">
                <h3>实践传非遗</h3>
                <p>打造实践熔炉，借跨学科项目发力，凭虚拟实验室赋能，淬炼文化自信璀璨结晶</p>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </section>

    <!-- 页面底部 -->
    <footer class="main-footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-section">
            <h4>关于我们</h4>
            <p>致力于保护和传承中华民族非物质文化遗产</p>
          </div>
          <div class="footer-section">
            <h4>快速链接</h4>
            <ul>
              <li><router-link to="/about">寻迹识非遗</router-link></li>
              <li><router-link to="/explore">科学解非遗</router-link></li>
              <li><router-link to="/heritage">实践传非遗</router-link></li>
            </ul>
          </div>
          <div class="footer-section">
            <h4>联系我们</h4>
            <p>邮箱: info@heritage.cn</p>
            <p>电话: 010-12345678</p>
          </div>
        </div>
        <div class="footer-bottom">
          <p>&copy; 2024 中华非遗. 保留所有权利.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
      showInteractive: false
    }
  },
  mounted() {
    // 启动动画序列
    this.startAnimationSequence();
  },
  methods: {
    /**
     * 启动动画序列
     * 1秒后背景图模糊，0.8秒后显示功能圆圈
     */
    startAnimationSequence() {
      // 1秒后开始转换
      setTimeout(() => {
        this.showInteractive = true;
      }, 1000);
    }
  }
}
</script>

<style scoped>
/* 首页特定样式 */
.home-page {
  min-height: 100vh;
}

/* 确保所有原始CSS样式生效 */
/* 样式已在全局CSS中定义，这里不需要重复 */
</style>